<template>
	<div class="account-detail">
		<div class="level">
			<div class="level__text">{{ translate("ui.level") }}</div>
			<div class="level__number">{{ level }}</div>
		</div>
		<div class="desc">
			<RaggedBoxBackground slug="account-detail" />
			<div class="line tiles-explored">
				<div class="text">{{ translate("ui.tiles_explored") }}</div>
				<div class="number">{{ tilesExplored }}</div>
			</div>
			<!-- <div class="line coins">
				<div class="text">{{ translate("ui.income") }}</div>
				<div class="number">
					{{ coinsIncome }}
					<AppMainIcon iconName="coins" :iconSize="14" />
				</div>
			</div> -->
		</div>
	</div>
</template>

<script lang="ts" setup>
// import AppMainIcon from "@/components/AppMainIcon.vue";
import { translate } from "@/utils/translate";
import RaggedBoxBackground from "./SVG/RaggedBoxBackground.vue";

interface Props {
	level: number;
	tilesExplored: number;
	// coinsIncome: number;
}

const {
	level,
	tilesExplored,
	// coinsIncome
} = defineProps<Props>();
</script>

<style lang="scss" scoped>
.account-detail {
	display: flex;
	box-shadow: 0 0 0.3125rem 0 rgba(35, 18, 4, 0.6);
	width: 100%;
	height: 3.5rem;

	.level {
		box-shadow: inset 0 0 0.5rem 0 rgba(0, 0, 0, 0.3);
		border-width: 0.075rem;
		border-style: solid;
		border-image-source: linear-gradient(
			to top,
			rgb(189, 144, 50),
			rgb(240, 211, 134)
		);
		border-image-slice: 1;
		background-image: linear-gradient(
			to top,
			rgb(78, 29, 97),
			rgb(134, 44, 173)
		);
		width: 3.5rem;
		height: 100%;

		@include flex-col-center;

		&__text {
			color: rgb(255, 243, 221);
			font-size: 0.8125rem;
		}
		&__number {
			margin-top: -0.625rem;
			color: rgb(244, 210, 120);
			font-weight: 800;
			font-size: 1.5rem;
		}
	}
	.desc {
		@include flex-col-evenly;
		position: relative;
		flex: 1;
		padding: 0.5rem 0.625rem;
		color: rgb(55, 38, 21);
		font-size: 0.8125rem;

		:deep(.ragged-box-bg) {
			position: absolute;
			z-index: -1;
			filter: drop-shadow(0 0 0.1rem rgba(49, 37, 22, 0.6));
			width: 100%;
			height: 100%;
		}

		.line {
			@include flex-row-between;
			width: 100%;

			.number {
				font-weight: 800;
			}
		}
	}
}
</style>
